export const hi = {
    LEFT: 'बाएँ ले जाएँ करने के लिए पिछले दिन.',
    RIGHT: 'सही स्थानांतरित करने के लिए अगले दिन.',
    DOWN: 'नीचे: अगले कदम के लिए पंक्ति में.',
    UP: 'ऊपर: स्थानांतरित करने के लिए पिछली पंक्ति.',
    PGUP: 'PgUp: स्थानांतरित करने के लिए पिछले महीने.',
    PGDOWN: 'PgDown: स्थानांतरित करने के लिए अगले महीने के लिए.',
    HOME: 'घर: स्थानांतरित करने के लिए पिछले वर्ष की है ।',
    END: 'अंत: स्थानांतरित करने के लिए अगले वर्ष है.',
    ESC: 'ईएससी/आज/बंद: बंद कैलेंडर.',
    TITLE: 'कुंजीपटल निर्देश'
};
